var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewArrowRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.206155 1.14613C-0.0687182 1.44675 -0.0687182 1.93423 0.206155 2.23485L4.42935 6.85398C4.7042 7.15461 5.14989 7.15461 5.42475 6.85398L9.64793 2.23485C9.92279 1.93423 9.92279 1.44675 9.64793 1.14613C9.37307 0.845497 8.92739 0.845497 8.65253 1.14613L4.92705 5.22089L1.20157 1.14613C0.926693 0.845497 0.481035 0.845497 0.206155 1.14613Z",
    fill: "#F84545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewArrowRed);
export default __webpack_public_path__ + "static/media/NewArrowRed.e71a20cf61e155a9a71aa51f2a43fe09.svg";
export { ForwardRef as ReactComponent };